import type { TaskContent } from "../../types/content-types";

type SoleBodyEntry = TaskContent[number] & { body: string };

/** True iff a content entry is exactly `{ body: string }` with no other keys. */
export function isSoleBodyEntry(entry: TaskContent[number] | undefined): entry is SoleBodyEntry {
    return !!entry && typeof entry.body === "string" && Object.keys(entry).length === 1;
}
